import React from 'react';
import PropTypes from 'prop-types';
import '../svg.css';


const Appliances = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >

            <g id="messages_officeFurniture" data-name="messages/officeFurniture">
                <g id="Logo"><rect id="frame" className="clsAppliances-1" width="36" height="36" rx="10" /></g>
                <path id="Combined-Shape" className="clsAppliances-2" d="M25,16V28a1,1,0,0,1-1,1H12a1,1,0,0,1-1-1V16h2v6a1,1,0,0,0,2,0h0V16H25ZM24,7a1,1,0,0,1,1,1v6H15V11a1,1,0,0,0-2,0h0v3H11V8a1,1,0,0,1,1-1Z" />
            </g>
        </svg>
    );
};

// ArrowheadLeft.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default Appliances;
